import React from "react"
import { Link } from "react-router-dom"

import "./errorScreen.scss"

const ErrorScreen = (props) => (
  <div className="error-screen-container">
    <div className="header">{props.message}</div>
    {props.backToHome && (
      <Link to="/" className="exit-button">
        Back to ETR Home
      </Link>
    )}
  </div>
)

export default ErrorScreen
